import React, { Component } from 'react'
import { Button, Icon, Modal, Spin, Table } from 'antd'
import _ from 'lodash'

import './ExportModal.scss'

export default class ExportModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            modalVisible: false,
        }

        this.handleClick = this.handleClick.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.handleConfirm = this.handleConfirm.bind(this)
        this.getExpandedTable = this.getExpandedTable.bind(this)
    }

    handleClick() {
        this.setState({ modalVisible: true })
    }

    handleCancel() {
        this.setState({ modalVisible: false })
    }

    handleConfirm() {
        this.setState({ modalVisible: false })
    }

    getExpandedTable(parentData) {
        const { onExport } = this.props
        const tableColumns = [{
            title: 'Payment Name',
            dataIndex: 'name',
            key: 'name'
        }, {
            title: 'Invoice',
            dataIndex: 'invoice',
            key: 'invoice',
            width: 100,
            render: (data, record) => {
                return (
                    <Icon className="pdf-download-btn" type="download" onClick={onExport.bind(this, parentData.project_id, parentData._id, 'invoice', record._id)}/>
                )
            }
        }, {
            title: 'Receipt',
            dataIndex: 'receipt',
            key: 'receipt',
            width: 100,
            render: (data, record) => {
                if (record.paid)
                    return (
                        <Icon className="pdf-download-btn" type="download" onClick={onExport.bind(this, parentData.project_id, parentData._id, 'receipt', record._id)}/>
                    )
            }
        }]
        if (parentData.terms_and_conditions.payments.length !== 0)
            return (
                <Table
                    className="expanded-payment-table"
                    rowKey={'_id'}
                    columns={tableColumns}
                    dataSource={parentData.terms_and_conditions.payments}
                    pagination={false}
                />
            )
    }

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(prevProps.loadingStatus, this.props.loadingStatus))
            console.log(this.props.loadingStatus)
    }

    render() {
        const { dataSource, onExport, loadingStatus } = this.props
        const { modalVisible } = this.state
        const isLoading = loadingStatus.isLoading && loadingStatus.tip === 'Exporting...'
        const tableColumns = [{
            title: 'Document Name',
            dataIndex: 'name',
            key: 'name'
        }, {
            title: 'Normal',
            dataIndex: 'normal',
            key: 'normal',
            width: 100,
            render: (data, record) => (
                <Icon className="pdf-download-btn" type="download" onClick={onExport.bind(this, record.project_id, record._id, record.type === 'work-progress-report' ? 'work-progress-report' : '')}/>
            )
        }, {
            title: 'WorkList',
            dataIndex: 'workList',
            key: 'workList',
            width: 100,
            render: (data, record) => {
                if (record.type === 'quotation' || record.type === 'sub-quotation' || record.type === 'notice')
                    return (
                        <Icon className="pdf-download-btn" type="download" onClick={onExport.bind(this, record.project_id, record._id, 'worklist')}/>
                    )
            }
        }]

        return (
            <div className="ExportModal-wrapper cheer-btn">
                <Button type="primary" size="large" onClick={this.handleClick}>Export</Button>
                <Modal
                    width="60%"
                    wrapClassName="ExportModal"
                    footer={null}
                    visible={modalVisible}
                    onCancel={this.handleCancel}
                    maskClosable={!isLoading}
                    closable={!isLoading}
                >
                    <Spin spinning={isLoading} tip={loadingStatus.tip}>
                        <p className="info">Select the document that you want to export.</p>
                        <div className="content">
                            <Table
                                className="exportable-document-table"
                                rowKey={'_id'}
                                columns={tableColumns}
                                dataSource={_.filter(dataSource, (doc) => doc.type !== 'working-progress')}
                                pagination={false}
                                scroll={{y: 250}}
                                size="small"
                                rowClassName={(record, index) => record.terms_and_conditions.payments.length === 0 ? 'no-payment' : ''}
                                expandedRowRender={this.getExpandedTable}
                            />
                        </div>
                        <div className="footer">
                            <Button type="primary" size="large" onClick={this.handleConfirm}>Done</Button>
                        </div>
                    </Spin>
                </Modal>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Commons/ExportModal/ExportModal.js